<script>
    import {player, colors, enemies} from '../store';
    import Player from './Player.svelte';
</script>

<svg class="h-full" viewBox="0 0 1 6">
    <rect x="0" y="0" width="1" height="1" fill="{$colors.gray[800]}" />
    <use xlink:href="#player"  x=".15" y=".15" width=".7" height=".7" />
    {#each $player.commands as {symbol}, i}
        <rect x="{i * 2 + .6}" y="11.2" width=".6" height=".6" rx=".2" fill="{$colors.blue[800]}" />
        <use xlink:href="#{symbol}" x="{i * 2 + .65}" y="11.25" width=".5" height=".5" />
    {/each}
</svg>
